<template>
  <div>
    水电费第三方
  </div>
</template>
<script>
import AMap from "vue-amap";
import Vue from "vue";
Vue.use(AMap);
let dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
let AMapKey = dataBranch.partyGroupConfigCacheMap.amapKey_webJs.configValue;
AMap.initAMapApiLoader({
  key: AMapKey,
  plugin: [
    "AMap.Autocomplete",
    "AMap.PlaceSearch",
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PolyEditor",
    "AMap.CircleEditor"
  ]
});

import { vehicleMap } from "@/api/vehiclemap";
export default {
  data() {
    return {
      vehicleCodes: "595d6d91ca694b58a9fd23e04df0b494",
      zoom: 12,
      center: [118.23492, 35.116317],
      arrjw: [],
      lines: [
        {
          path: [[116.39, 39.91, 116.37, 39.91]],
          strokeDasharray: [10, 10],
          strokeColor: "#FF33FF", //线颜色
          strokeOpacity: 1, //线透明度
          strokeWeight: 3, //线宽
          strokeStyle: "solid", //线样式
          events: {
            click: () => {}
          }
        }
      ]
    };
  },
  created() {},
  methods: {
    mapquery() {
      vehicleMap(this.vehicleCodes).then(response => {
        response.data.map(item => {
          this.arrjw.push(Number(item.longitude));
          this.arrjw.push(Number(item.latitude));
        });
        this.center = this.arrjw;
      });
    }
  }
};
</script>

<style>
.amap-page-container {
  height: 800px;
}
.grid-content {
  border-bottom: 1px solid rgb(109, 104, 104);
}
.grid-content p {
  color: rgb(109, 104, 104);
  text-align: center;
}
.el-button {
  position: fixed;
  top: 100px;
  left: 100px;
  z-index: 9;
  height: 48px;
  width: 48px;
}
</style>
